"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _ramda = require("ramda");
var _Collapsed = require("../../../../../ui/Collapsed");
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _RenderWhen = _interopRequireDefault(require("../../../../../RenderWhen"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getIsList = function getIsList(content) {
  return Array.isArray(content);
};
var DescriptionByAI = function DescriptionByAI(_ref) {
  var description = _ref.description;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    initialOpen: true,
    title: t('COLLAPSED_AI_DESCRIPTION'),
    className: _styles.default.collapsed
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.SUCCESS
  }, t('AI_DESCRIPTION_LABEL')), (0, _ramda.map)(function (_ref2) {
    var title = _ref2.title,
      content = _ref2.content;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.description,
      key: title
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.description__title
    }, title), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
      isTrue: getIsList(content)
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: _styles.default.description__list
    }, (0, _ramda.map)(function (item) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: item
      }, item);
    }, content))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
      isTrue: true
    }, content)));
  }, description));
};
DescriptionByAI.T = {
  description: _propTypes.default.array
};
var _default = exports.default = (0, _react.memo)(DescriptionByAI);